import { Component, OnInit, ViewEncapsulation, ViewChild, AfterViewChecked, OnDestroy, ViewContainerRef, ChangeDetectionStrategy } from '@angular/core';
import { Icon } from '../../models/icon';
import { ModalComponent } from '../modal/modal.component';
import { Subscription } from 'rxjs';
import { BrokerInfo } from '../../models/BrokerInfo';
import { Illustration } from '../../models/illustration';
import { SessionService } from '../../../core/services/session.service';
import { AnimationItem } from 'lottie-web';
import { DistributionChannel } from '../../models/distributionChannelType';
import { ResourceModel, ResourceModelName } from '../../models/ResourceModel';
import { AgTranslateService } from '@ag/vc.ag-core/translate';
import { BrokerToolComponent } from '../broker-tool/broker-tool.component';
import { AgAuthenticationService } from '@ag/vc.ag-core/authentication';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
declare let AG: any;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
declare let Microsoft: any;
@Component({
  selector: 'app-help-widget',
  templateUrl: './help-widget.component.html',
  styleUrls: ['./help-widget.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HelpWidgetComponent implements OnInit,AfterViewChecked,OnDestroy {
  Icon = Icon;
  selectedBrokerInfo: BrokerInfo;
  illustration = Illustration;
  @ViewChild('brokerModal') brokerModal: ModalComponent;
  isKnownBrokerFlow: boolean;
  buttonAnimation: AnimationItem;
  // currentLanguage: string;
  isBrokerFlow: boolean;
  isAgentAvailable: boolean;
  isChatMinimised = false;
  isChatSDKReady = false;
  email: string;
  signature: string;
  signatureGlobal: ResourceModel;
  emailGlobal: ResourceModel;
  subscriptions: Subscription = new Subscription();
  fromWidget: boolean;  
  isBrokerSearchToolShown = false;
  brokerLogoCustomChange: string;
  // @ViewChild('brokerSearchTool') brokerTool: ElementRef<HTMLInputElement>;
  @ViewChild('brokerToolContainerFromWidget', {read: ViewContainerRef}) brokerToolContainerFromWidget: ViewContainerRef;

  protected get currentLanguage(): string {
    return this.translateService.currentLang;
  }

  constructor(
    private readonly session: SessionService,
    private readonly authenticationService: AgAuthenticationService,
    private readonly translateService: AgTranslateService
  ) { }

  ngOnInit(): void {
    this.isBrokerFlow = this.session.getUserParams().distributionChannel === DistributionChannel.Broker ? true : false;
    this.setCustomercareDetails();
    this.subscriptions.add(
      this.translateService.onLangChange.subscribe(() => {
        this.setCustomercareDetails();
      }));
  }
  ngAfterViewChecked(){
      this.setCustomercareDetails();
  }
  setCustomercareDetails(){
    this.emailGlobal= this.session.filterResource(ResourceModelName.Email,this.session.getResourceDetails());
    this.email= this.currentLanguage== 'fr'  ? this.emailGlobal?.FrenchValue : this.emailGlobal?.DutchValue;
    this.signatureGlobal = this.session.filterResource(ResourceModelName.Signature,this.session.getResourceDetails());
    this.signature = this.currentLanguage== 'fr'  ? this.signatureGlobal?.FrenchValue : this.signatureGlobal?.DutchValue;
  }

  public onWidgetOpen(openingFlag: boolean): void {
    if (openingFlag){
      this.selectedBrokerInfo = this.session.getBrokerDetails();
      this.isKnownBrokerFlow = this.session.isKnownBrokerFlow;
      this.brokerLogoCustomChange = this.selectedBrokerInfo?.logoUrl + '.png';
      // chat is only for uppie flow
      if (!this.isBrokerFlow){
        try{
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          let omnichannelLoader: any;
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access, prefer-const
          omnichannelLoader = new AG.SecureUppieLoader(() => {
            if (this.translateService.currentLang === 'nl') {
              // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
              this.authenticationService.isAuthenticated ? omnichannelLoader.LoadWidget("Uppie Authenticated NL") : omnichannelLoader.LoadWidget("Uppie UnAuthenticated NL");
            } else {
              // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
              this.authenticationService.isAuthenticated ? omnichannelLoader.LoadWidget("Uppie Authenticated FR") : omnichannelLoader.LoadWidget("Uppie UnAuthenticated FR");
            }
            // checking for agent's availability
            // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
            omnichannelLoader.CanStartChat((_queueName: string, agentCount: number) => {
              this.isAgentAvailable = agentCount ? true : false;
            });
          });
        }
        catch(e){
          console.error('Chat could not be loaded');
        }
      }
    }
  }

  searchBroker(_hasBroker: boolean): void{    
    this.isBrokerSearchToolShown = true;
    this.brokerModal.openModal();
    // setTimeout(() => {
    //   this.renderer.setAttribute(this.brokerTool.nativeElement,"language", this.currentLanguage);
    // });
    if(this.isBrokerSearchToolShown){      
      this.brokerToolContainerFromWidget.clear();
      const brokerComponent = this.brokerToolContainerFromWidget.createComponent(BrokerToolComponent);
      brokerComponent?.setInput('hasBroker', true);
      brokerComponent?.setInput('fromWidget', true);
      brokerComponent?.setInput('culture', this.currentLanguage);
      brokerComponent?.instance['BrokerSelectedFromWidget'].subscribe(() => {
        this.onBrokerSelectedFromWidget();
      })
    }
    this.fromWidget = true;
  }

  onBrokerToolToogle(event: string): void{
    if(event !== 'open'){
      this.isBrokerSearchToolShown = false;
      // setTimeout(() => {
      //   delete window?.google?.maps;
      // },1000);
    }
  }

  onBrokerSelectedFromWidget(): void{
    // const queryParamObject = {
    //   brokerId: sessionStorage.getItem('SelectedBrokerId'),
    //   isPublicId: false
    // };
    // this.simulationService.getBrokerContent(queryParamObject).pipe(
    //   catchError((error) => {
    //     console.log(error);
    //     return EMPTY;
    //   })
    // ).subscribe((res: BrokerInfo) => {
    //   this.selectedBrokerInfo = res;
    //   const userParams = this.session.getUserParams();
    //   userParams.partnercode = sessionStorage.SelectedBrokerPId;
    //   this.session.setModifiedUserParam(userParams); // setting the partner code after selection from widget
    //   this.session.setHeaderContext(res.BrokerLogoUrl, res.WebsiteUrl ? res.WebsiteUrl : null); // changing the header
    //   this.session.setBrokerDetails(res); // setting the broker details in session
    // });
    this.selectedBrokerInfo = this.session.getBrokerDetails();
    this.brokerLogoCustomChange = this.selectedBrokerInfo?.logoUrl + '.png';
    this.session.setBrokerDetails(this.selectedBrokerInfo);
    sessionStorage.setItem('SelectedBrokerPId', this.selectedBrokerInfo.publicId);
    const userParams = this.session.getUserParams();
    userParams.partnercode = sessionStorage.getItem('SelectedBrokerPId');
    this.session.setModifiedUserParam(userParams);
    this.session.setHeaderContext(this.selectedBrokerInfo.logoUrl ? this.brokerLogoCustomChange : null, this.selectedBrokerInfo.websiteUrl ? this.selectedBrokerInfo.websiteUrl : null, true);
    this.brokerModal.closeModal();
    this.fromWidget = false;
  }

  public onChatSDKReady(flag: boolean): void{
    this.isChatSDKReady = flag;
  }

  public openChat(): void {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
    Microsoft?.Omnichannel?.LiveChatWidget?.SDK?.startChat();
  }

  public onChatMinimize(chatMinimizedFlag: boolean): void{
    this.isChatMinimised = chatMinimizedFlag;
  }
  public closeChat(): void{
    this.isChatMinimised = false;
  }

  ngOnDestroy(): void {
   this.subscriptions.unsubscribe();
  }

}
